import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1022BuSperreStatus: 'idle',
    startProcess1022BuSperreError: undefined as any,
    loadUserParamsProcess1022BuSperreStatus: 'idle',
    loadUserParamsProcess1022BuSperreError: undefined as any,

    process1022BuSperreList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1022BuSperre = createAsyncThunk('process1022BuSperreSlice/startProcess1022BuSperre', async ({ process1022BuSperre }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1022BuSperre/`,
        prepareData(process1022BuSperre),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1022BuSperreStatus } = getState().process1022BuSperreSlice
        return startProcess1022BuSperreStatus !== 'pending'
    }
})

export const loadUserParamsProcess1022BuSperre = createAsyncThunk('process1022BuSperreSlice/loadUserParamsProcess1022BuSperre', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1022BuSperre/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1022BuSperreStatus } = getState().process1022BuSperreSlice
        return loadUserParamsProcess1022BuSperreStatus !== 'pending'
    }
})

const Process1022BuSperreSlice = createSlice({
    name: 'process1022BuSperreSlice',
    initialState,
    reducers: {
        resetstartProcess1022BuSperre: (state) => {
            state.job = undefined
            state.startProcess1022BuSperreError = undefined
        },
        resetstartProcess1022BuSperreError: (state) => {
            state.startProcess1022BuSperreError = undefined
        },
        resetloadUserParamsProcess1022BuSperre: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1022BuSperreError = undefined
        },
        resetloadUserParamsProcess1022BuSperreError: (state) => {
            state.loadUserParamsProcess1022BuSperreError = undefined
        },
        removeFromProcess1022BuSperreListById: (state, action) => {
            state.process1022BuSperreList = state.process1022BuSperreList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1022BuSperreListByIds: (state, action) => {
            state.process1022BuSperreList = state.process1022BuSperreList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1022BuSperreList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1022BuSperreStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1022BuSperreList = []
            state.startProcess1022BuSperreStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1022BuSperre.pending, (state) => {
            state.startProcess1022BuSperreStatus = 'pending'
            state.startProcess1022BuSperreError = undefined
        })
        builder.addCase(startProcess1022BuSperre.fulfilled, (state, action) => {
            state.startProcess1022BuSperreStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1022BuSperre.rejected, (state, action) => {
            state.startProcess1022BuSperreStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1022BuSperreError = action.error.message
            } else {
                state.startProcess1022BuSperreError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1022BuSperre.pending, (state) => {
            state.loadUserParamsProcess1022BuSperreStatus = 'pending'
            state.loadUserParamsProcess1022BuSperreError = undefined
        })
        builder.addCase(loadUserParamsProcess1022BuSperre.fulfilled, (state, action) => {
            state.loadUserParamsProcess1022BuSperreStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1022BuSperre.rejected, (state, action) => {
            state.loadUserParamsProcess1022BuSperreStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1022BuSperreError = action.error.message
            } else {
                state.loadUserParamsProcess1022BuSperreError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1022BuSperre,
    resetstartProcess1022BuSperreError,
    resetloadUserParamsProcess1022BuSperre,
    resetloadUserParamsProcess1022BuSperreError,
    removeFromProcess1022BuSperreListById,
    removeFromProcess1022BuSperreListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1022BuSperreSlice.actions
export default Process1022BuSperreSlice.reducer
